import { 
    takeLatest, 
    put, 
    fork, 
    call 
} from "redux-saga/effects";
import { DECISIONING_DASHBOARD_ACTIONS } from "../constants/actions";
import DecisioningDashboardService from "../services";
import {
    fetchedDesisioningDashboardColumns,
    failedFetchDesisioningDashboardColumns,

    fetchDesisioningDashboardRows,
    fetchedDesisioningDashboardRows,
    failedFetchDesisioningDashboardRows,

    fetchedDesisioningDashboardProceed,
    failedFetchDesisioningDashboardProceed,

    fetchedDesisioningDashboardRefer,
    failedFetchDesisioningDashboardRefer,

    fetchedDesisioningDashboardSanction,
    failedFetchDesisioningDashboardSanction,
} from "../actions";
// import columns from "../extras/columns.json";
import {message} from "antd";
// import rows from "../extras/rows.json";

function* fetchDesisioningDashboardColumns() {
    // let error = null;
    // let data = columns;
    const { data, error } = yield call(DecisioningDashboardService.getDashboardColumns);
    if(!error) {
        yield put(fetchedDesisioningDashboardColumns(data));
    }else {
        yield put(failedFetchDesisioningDashboardColumns(error));
    }
}

function* fetchDesisioningDashboardRow({payload: {page, pageSize, filters, stageId}}) {
    const { data, error } = yield call(DecisioningDashboardService.getDashboardRows, page, pageSize, filters, stageId);
    if(!error) {
        yield put(fetchedDesisioningDashboardRows(page, pageSize, filters, data, stageId));
    }else {
        yield put(failedFetchDesisioningDashboardRows(page, pageSize, filters, error, stageId));
    }
}

function* fetchDesisioningDashboardProceed({payload: {case_task_ids, this_stage, this_user, remark, page, pageSize, filters, stageId}}) {
    const { data, error } = yield call(DecisioningDashboardService.bulkProceed, case_task_ids, this_stage, this_user, remark);
    if(!error) {
        yield put(fetchedDesisioningDashboardProceed(case_task_ids, this_stage, this_user, remark, data));
        yield put(fetchDesisioningDashboardRows(page, pageSize, filters, stageId));
        message.success("Cases proceeded successfully");
    }else {
        yield put(failedFetchDesisioningDashboardProceed(case_task_ids, this_stage, this_user, remark, error));
        message.error("Unable to proceed cases");
    }
}

function* fetchDesisioningDashboardRefer({payload: {case_task_ids, this_stage, this_user, remark, page, pageSize, filters, stageId}}) {
    const { data, error } = yield call(DecisioningDashboardService.bulkRefer, case_task_ids, this_stage, this_user, remark);
    if(!error) {
        yield put(fetchedDesisioningDashboardRefer(case_task_ids, this_stage, this_user, remark, data));
        yield put(fetchDesisioningDashboardRows(page, pageSize, filters, stageId));
        message.success("Cases referred back successfully");
    }else {
        yield put(failedFetchDesisioningDashboardRefer(case_task_ids, this_stage, this_user, remark, error));
        message.error("Unable to refer back cases");
    }
}


function* fetchDesisioningDashboardSanction({payload: {caseIds, sanctionConditionObj, page, pageSize, filters, stageId}}) {
    const { data, error } = yield call(DecisioningDashboardService.bulkSanction, caseIds, sanctionConditionObj);
    if(!error) {
        yield put(fetchedDesisioningDashboardSanction(caseIds, sanctionConditionObj, data));
        yield put(fetchDesisioningDashboardRows(page, pageSize, filters, stageId));
        message.success("Cases sanctioned successfully");
    }else {
        yield put(failedFetchDesisioningDashboardSanction(caseIds, sanctionConditionObj, error));
        message.error("Unable to sanction cases");
    }
}


export default fork(function*() {
    yield takeLatest(
        DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_COLUMNS,
        fetchDesisioningDashboardColumns
    );
    yield takeLatest(
        DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_ROWS,
        fetchDesisioningDashboardRow
    );
    yield takeLatest(
        DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_PROCEED,
        fetchDesisioningDashboardProceed
    );
    yield takeLatest(
        DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_REFER,
        fetchDesisioningDashboardRefer
    );
    yield takeLatest(
        DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_SANCTION,
        fetchDesisioningDashboardSanction
    );
});